module.exports = __webpack_public_path__ + "static/media/stats-3000users.99d39e14.png";